<div>
  @for (task of tasks; track task) {
  <vw-task [task]="task"></vw-task>
  }

  <div class="pb-6 pt-6">
    <!-- Articles  -->
    @if (!isLoading) {
    <div class="flex flex-col gap-4 mt-8 mb-28">
      <h2 class="text-primary-title text-2xl font-semibold">
        {{ "home.articles.title" | translate }}
      </h2>
      @for (article of articles; track article) {
      <vw-article [article]="article"></vw-article>
      }
    </div>
    }
  </div>
</div>